module.exports = __webpack_public_path__ + "media/images/symbols/next-button-cf38d35bc8fea7b5af56c98a7c7aa210.svg";